import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { InterpolationParameters, TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'translateInsensitive',
  pure: false,
})
export class TranslateInsensitivePipe implements PipeTransform {
  private translate = inject(TranslateService);

  // Resolves a dot-separated key even when a dynamic segment's casing doesn't match the stored translation key.
  transform(key: string, params?: InterpolationParameters): string {
    const exact = this.translate.instant(key, params);
    if (exact !== key) {
      return exact;
    }

    const segments = key.split('.');
    for (let i = segments.length - 1; i >= 0; i--) {
      const original = segments[i];
      for (const variant of this.getCasingVariants(original)) {
        if (variant === original) {
          continue;
        }
        segments[i] = variant;
        const candidateKey = segments.join('.');
        const result = this.translate.instant(candidateKey, params);
        if (result !== candidateKey) {
          return result;
        }
      }
      segments[i] = original;
    }

    return exact;
  }

  private getCasingVariants(segment: string): string[] {
    return [
      segment.toLowerCase(),
      segment.toUpperCase(),
      segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase(),
    ];
  }
}
